const css = `.rich-text-editor {
  border: 1px solid var(--border-strong);
  border-radius: 10px;
  overflow: hidden;
}
.rich-text-editor.fullscreen {
  position: fixed;
  inset: 0;
  z-index: 1100;
  background: var(--surface-raised);
  border-radius: 0;
  display: flex;
  flex-direction: column;
}
.rich-text-editor.fullscreen .rich-text-content {
  flex: 1;
  max-height: unset;
}
.rich-text-editor.p-invalid {
  border-color: var(--danger);
}

.rich-text-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 2px;
  padding: var(--space-2) var(--space-2);
  border-bottom: 1px solid var(--border-strong);
  background: var(--surface-sunken);
}
.rich-text-toolbar.rich-text-toolbar-disabled {
  opacity: 0.6;
  pointer-events: none;
}

.rich-text-toolbar-divider {
  align-self: stretch;
  width: 1px;
  margin: 4px 4px;
  background: var(--border-strong);
}

.rich-text-toolbar-divider-push-right {
  margin-left: auto;
}

.rich-text-toolbar-color {
  position: relative;
  display: inline-flex;
  flex: 0 0 auto;
}

.rich-text-toolbar-color-letter {
  position: absolute;
  inset: 0 0 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--primary-color);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-medium);
  pointer-events: none;
}

.rich-text-toolbar .p-colorpicker .p-colorpicker-preview {
  width: 32px;
  height: 32px;
  flex: 0 0 auto;
  padding: 24px 8px 4px;
  border: none;
  background-clip: content-box;
  cursor: pointer;
}

.rich-text-toolbar-dropdown {
  min-width: 90px;
  height: 32px;
}
.rich-text-toolbar-dropdown .p-dropdown-label {
  padding: 4px 8px;
  font-size: var(--font-size-sm);
}

.rich-text-toolbar-btn-active {
  background: var(--accent-subtle) !important;
  color: var(--accent) !important;
}

.rich-text-toolbar-btn-bold .p-button-label {
  font-weight: var(--font-weight-bold);
}

.rich-text-toolbar-btn-italic .p-button-label {
  font-style: italic;
}

.rich-text-toolbar-btn-underline .p-button-label {
  text-decoration: underline;
}

.rich-text-toolbar-btn-strike .p-button-label {
  text-decoration: line-through;
}

.rich-text-toolbar-btn-redo .pi {
  transform: scaleX(-1);
  display: inline-block;
}

.rich-text-url-popover form {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  padding: 4px;
  min-width: 260px;
}
.rich-text-url-popover label {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
}

.rich-text-url-popover-input {
  display: flex;
  gap: var(--space-2);
}

.rich-text-content {
  min-height: 200px;
  max-height: 600px;
  overflow-y: auto;
  padding: 12px;
}
.rich-text-content .ProseMirror {
  outline: none;
  min-height: 180px;
}
.rich-text-content .ProseMirror p {
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-regular);
  color: var(--text);
}
.rich-text-content .ProseMirror p.is-editor-empty:first-child::before {
  content: attr(data-placeholder);
  color: var(--text-subtle);
  font-weight: var(--font-weight-regular);
  float: left;
  height: 0;
  pointer-events: none;
}
.rich-text-content .ProseMirror img {
  max-width: 900px;
  max-width: 100%;
}
.rich-text-content .ProseMirror a {
  color: var(--accent);
  cursor: pointer;
}
.rich-text-content .ProseMirror blockquote {
  border-left: 3px solid var(--border-strong);
  margin-left: 0;
  padding-left: 12px;
  color: var(--text-subtle);
}
.rich-text-content .ProseMirror table {
  border-collapse: collapse;
  width: 100%;
}
.rich-text-content .ProseMirror table td,
.rich-text-content .ProseMirror table th {
  border: 1px solid var(--border-strong);
  padding: var(--space-2) var(--space-2);
}
.rich-text-content .ProseMirror table th {
  background: var(--surface-sunken);
  font-weight: var(--font-weight-semibold);
}

.rich-text-video-embed {
  position: relative;
  width: 100%;
  padding-top: 56.25%;
  margin: 8px 0;
}
.rich-text-video-embed iframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border-radius: 6px;
}

@media (max-width: 768px) {
  .rich-text-content {
    max-height: 500px;
  }
}
@media (max-width: 480px) {
  .rich-text-content {
    max-height: 400px;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
